import React, { useState } from "react";
import styled from "styled-components";

const NewsletterContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 40px;
  align-items: center;
  justify-content: space-between;
  width: 100%;

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 30px;
  }
`;

const TextContainer = styled.div`
  max-width: 700px;

  h1 {
    color: rgba(255, 255, 255, 0.66);
    text-align: center;
    font-family: 'MedievalSharp', serif;
    font-size: clamp(1.5rem, 5vw, 2.8rem);
    padding-bottom: clamp(15px, 3vw, 25px);
  }

  p {
    color: white;
    text-align: center;
    font-family: 'Mozilla Text', serif;
    font-size: clamp(1rem, 2vw, 1.5rem);
    line-height: 1.6;
  }
`;

const SpecialText = styled.span`
  font-weight: bold;
  font-style: italic;
`;

const FormContainer = styled.div`
  form {
    display: flex;
    flex-direction: column;
    gap: 10px;
  }

  label {
    color: white;
    font-family: 'Mozilla Text', serif;
    font-size: clamp(1rem, 2vw, 1.5rem);
  }

  input {
    padding: 10px;
    font-family: 'Mozilla Text', serif;
    font-size: clamp(1rem, 2vw, 1.5rem);
    border-radius: 10px;
    border: 2px solid #caaeecff;
    background: rgba(255,255,255,0.85);

    &:focus {
      outline: none;
      border-color: #ba9debbb;
    }
  }

  .checkbox-row {
    display: flex;
    gap: 10px;

    input[type="checkbox"] {
      width: 28px;
      height: 28px;
      accent-color: #ba9debbb;
    }

    span {
      color: white;
      font-family: 'Mozilla Text', serif;
      font-size: clamp(0.9rem, 2vw, 1.1rem);
    }
  }

  button {
    background-color: #caaeecff;
    color: white;
    font-family: 'Mozilla Text', serif;
    font-size: clamp(1rem, 2vw, 1.5rem);
    font-weight: bold;
    align-self: center;
    margin-top: 15px;
    padding: 10px;
    border: none;
    border-radius: 15px;
    cursor: pointer;
    transition: background-color 0.3s ease;

    &:hover {
      background-color: #ba9debbb;
    }
  }

  .success-message {
    color: white;
    font-family: 'Mozilla Text', serif;
    font-size: clamp(0.9rem, 2vw, 1.1rem);
    text-align: center;
    min-height: 20px;  
  }
`;

const Newsletter = () => {
  const [email, setEmail] = useState("");
  const [consent, setConsent] = useState(false);
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();

    const payload = { email, consent };

    setEmail("");
    setConsent(false);
    setSubmitted(true);

    fetch("https://anna-miki-backend.onrender.com/api/subscribe", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    }).catch((err) => {
      console.error("Background newsletter signup error:", err);
    });
  };

  return (
    <NewsletterContainer>

      <TextContainer>

        <h1>Join the Newsletter</h1>

        <p>
          Join the Newsletter and get the first two chapters of <SpecialText>“When the butterflies are gone”</SpecialText> for free.
          {/* Sign up to receive the latest news on Anna Miki’s books, sneak peeks of upcoming releases, and exclusive behind-the-scenes content. 
          Be part of the journey and get early access to special updates! */}
        </p>

      </TextContainer>

      <FormContainer>

        <form onSubmit={handleSubmit}>

          <label>Email*:</label>
          
          <input
            type="email"
            placeholder="Enter your email..."
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />

          <div className="checkbox-row">

            <input
              type="checkbox"
              checked={consent}
              onChange={(e) => setConsent(e.target.checked)}
              required
            />
            
            <span>
              I agree to receive emails, with the understanding that I may easily opt-out at any time after signing up.
            </span>

          </div>

          <button type="submit">Sign up</button>

          <p className="success-message">
            {submitted ? "Welcome! Check your inbox ✉" : ""}
          </p>

        </form>
      
      </FormContainer>

    </NewsletterContainer>
  );
};

export default Newsletter;
